module.exports = __webpack_public_path__ + "assets/img/YCSC-4.0127da89.png";